import { SAVE_DEFULT_DOCUMENT_TEMPLATE, TEMPLATE_TYPE } from "../actions";

export const getdocumentType = (state = false, action) => {
  switch (action.type) {
    case TEMPLATE_TYPE:
      return action.payload;
    default:
      return state;
  }
};

export const saveDefaultDocumentTemplate = (state = false, action) => {
  switch (action.type) {
    case SAVE_DEFULT_DOCUMENT_TEMPLATE:
      return action.payload;
    default:
      return state;
  }
};
